"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _parseJSON = _interopRequireDefault(require("../../../common/utils/parseJSON"));

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function orderByTimestamp(a, b, c) {
  return Array.from(b.values()).reduce(function (b, d) {
    var e = d.metadata ? (0, _parseJSON["default"])(d.metadata) : {},
        f = e.timestamp,
        g = e.xPercent,
        h = e.yPercent,
        i = e.assetId,
        j = e.clipId,
        k = e.clipCommentTime,
        l = d.createdByUser.userId;
    if (c && j && j !== c) return b;
    var m = !Number.isNaN(+f) && !Number.isNaN(+g) && !Number.isNaN(+h);
    if (!m) return b;

    var n = _objectSpread(_objectSpread({
      timestamp: f,
      xPercent: g,
      yPercent: h,
      colour: a[l]
    }, j ? {
      clipId: j,
      clipCommentTime: k
    } : {
      assetId: i
    }), d),
        o = b.findIndex(function (a) {
      return n.timestamp < a.timestamp;
    }),
        p = -1 < o ? o : b.length;

    return [].concat((0, _toConsumableArray2["default"])(b.slice(0, p)), [n], (0, _toConsumableArray2["default"])(b.slice(p)));
  }, []).map(function (a, b) {
    return _objectSpread(_objectSpread({}, a), {}, {
      number: b + 1
    });
  });
}

var _default = orderByTimestamp;
exports["default"] = _default;